import Header from "../../components/Header";
import BoardContainer from '../../containers/BoardContainer';
export default function HomePage(){
    return (
        <div>
         <Header />
         <BoardContainer />
         {/* <Footer /> */}
        </div>
      );
}